import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ChevronRightIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M8.3 5.3a1 1 0 0 1 1.4 0l6 6c.4.4.4 1 0 1.4l-6 6a1 1 0 0 1-1.4-1.4l5.3-5.3-5.3-5.3a1 1 0 0 1 0-1.4Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ChevronRightIcon;
